<template>
    <client-page class="wrap--sub">
        <sub-visual :visual="title" :class="className" />
        <div class="contents">
            <div class="container">
                <v-row>
                    <v-col>
                        <view-organization v-if="isOrganization" :expert="expert" />
                        <view-supporter v-if="isSupporter" :expert="expert" />
                    </v-col>
                    <v-col cols="3" class="py-6">
                        <view-avatar :expert="expert" />
                    </v-col>
                </v-row>
                <view-worker v-if="isOrganization" :expert="expert" />
                <view-contact v-if="isSupporter" v-model="expert" />
                <view-descriptions v-model="expert" />
                <view-card>
                    <v-row>
                        <v-col cols="auto">
                            <v-btn outlined color="grey darken-1" class="rounded-0" @click="goList">리스트</v-btn>
                        </v-col>
                        <v-spacer />
                        <v-col v-if="isExpert" cols="auto">
                            <v-btn outlined color="secondary darken-1" class="rounded-0" to="/experts/modify">수정하기</v-btn>
                        </v-col>
                    </v-row>
                </view-card>
            </div>
        </div>
    </client-page>
</template>

<script>
import api from "@/api";
import { INDIVIDUAL_KINDS, USER_TYPES } from "@/assets/data/CONSTANTS";

import ViewCard from "@/components/client/experts/view-card.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import ViewWorker from "@/components/client/experts/view-worker.vue";
import ViewContact from "@/components/client/experts/view-contact.vue";
import ViewSupporter from "@/components/client/experts/view-supporter.vue";
import ViewDescriptions from "@/components/client/experts/view-descriptions.vue";
import ViewOrganization from "@/components/client/experts/view-organization.vue";
import ViewAvatar from "@/components/client/experts/view-avatar.vue";

export default {
    components: {
        ViewCard,
        SubVisual,
        ClientPage,
        ViewWorker,
        ViewContact,
        ViewSupporter,
        ViewDescriptions,
        ViewOrganization,
        ViewAvatar,
    },
    props: {
        _expert: String,
    },
    computed: {
        isOrganization() {
            return this.expert?.type == USER_TYPES.ORGANIZATION;
        },
        isSupporter() {
            return this.expert?.kind == INDIVIDUAL_KINDS.SUPPORTER.value;
        },
        isExpert() {
            return this.expert?._id == this.$store.state?.payload?._user;
        },
        title() {
            if (this.isOrganization) return "전문기업 검색";
            if (this.isSupporter) return "전문가 검색";
        },
        className() {
            if (this.isOrganization) return "sv3";
            if (this.isSupporter) return "sv4";
        },
    },
    data() {
        return {
            expert: null,
        };
    },
    methods: {
        async init() {
            try {
                const typeName_current = this.$route.path.split("/")[2];
                const { expert } = await api.v1.experts.get({ _id: this._expert });
                if (expert) {
                    this.expert = expert;
                    const { type } = expert;
                    if (type !== USER_TYPES[typeName_current.toUpperCase()]) {
                        const typeName_new = type.split("_")[1].toLowerCase();
                        this.$router.replace(`/experts/${typeName_new}/${expert._id}`);
                    }
                } else this.$router.replace(`/experts/${typeName_current}`);
            } catch (error) {
                this.$handleError(error);
            }
        },
        goList() {
            this.$router.go(-1);
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style></style>
